export default __webpack_public_path__ + "static/media/cart-gray.833cb16e.svg";